import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedFeaturesReducer(state = initialState.selectedFeatures, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_FEATURES_SUCCESS:
      return action.selectedFeatures;
    default:
      return state;
  }
}
